import * as React from 'react';
import { DateTimeFormatterOptions, DateTypes, useDateTimeFormatter } from '../../hooks/useDateTimeFormat';

export type DateTimeFormatterExtendedProps = DateTimeFormatterOptions & {
  date?: DateTypes;
  id?: string;
  className?: string;
  div?: WrapDateInDiv;
  dataTest?: string;
};

type WrapDateInDiv = boolean;

/**
 * Simple wrapper around the useDateTimeFormatter hook. Allows hook
 * be used like a React component supporting all the same properties.
 *
 * For example:
 *
 * <DateTimeFormatter format={DateTimeFormats.LONG_DAY_MONTH} includeTime useLong />
 *
 * Use the 'div' prop to wrap the date in a div instead of a span.
 *
 * Can be used as a Styled Component.
 *
 */
export const DateTimeFormatter = ({ dataTest, date, id, className, div, ...props }: DateTimeFormatterExtendedProps) => {
  const { dateTimeFormatter } = useDateTimeFormatter();
  const formattedDate = dateTimeFormatter(date, { ...props });

  const Tag = div ? 'div' : 'span';

  return (
    <Tag data-test={dataTest} id={id} className={className}>
      {formattedDate}
    </Tag>
  );
};
